import type { RouterInputs, RouterOutputs } from "@/trpc";

export type ProviderImportScope = {
  organizationBusinessUnitId: string;
  providerUserId: string;
  expectedAffiliationId?: string;
};
export type ProviderOfferList =
  RouterOutputs["credentials"]["listProviderCredentialOffersForBu"];
export type ProviderOffer = ProviderOfferList["offers"][number];
export type ProviderOfferSelection = ProviderOffer & {
  selectedFieldPaths?: string[];
};
export type ProviderFieldDraft = {
  expectedVersion: string;
  selectedFieldPaths: string[];
};
export type ProviderOfferDetail =
  RouterOutputs["credentials"]["getProviderCredentialOfferForBu"];
export type ProviderOfferDocument =
  ProviderOfferDetail["sourceDocuments"][number];
export type ProviderImportItem =
  RouterInputs["credentials"]["importProviderCredentialsForBu"]["items"][number];
export enum ProviderOfferFilter {
  Available = "available",
  Dismissed = "dismissed",
  All = "all",
}

export enum ProviderOfferAction {
  Import = "import",
  Dismiss = "dismiss",
}

export type ProviderOfferConfirmation = {
  action: ProviderOfferAction;
  offers: ProviderOfferSelection[];
};

export type ProviderOfferProgress = ProviderOfferConfirmation & {
  completed: number;
};
